import Menu from "@/router/menu";

const routes = [];
Menu.forEach((parent) => {
  /** Si le parent a un nom on le push */
  if (parent.name) {
    routes.push({
      path: parent.path,
      component: parent.component,
      name: parent.name,
      redirect: parent.redirect,
      beforeEnter: parent.beforeEnter,
      props: parent?.props ?? false,
    });
  }

  const children = parent.submenu || [];
  children.forEach((child) => {
    /** Génération des routes enfants */
    routes.push({
      path: parent.path + child.path,
      component: child.component,
      name: `${parent.name}_${child.name}`,
      alias: child.alias,
      beforeEnter: child.beforeEnter,
      props: child?.props ?? false,
      meta: {
        title: child.title,
        icon: child.icon,
        goBackBtn: child.goBackBtn,
        permissions: child.permissions,
      },
    });

    /** Génération des routes "petits-enfants" */
    const grandChildren = child.submenu || [];
    grandChildren.forEach((subchild) => {
      routes.push({
        path: parent.path + child.path + subchild.path,
        component: subchild.component,
        name: `${parent.name}_${child.name}_${subchild.name}`,
        alias: subchild.alias,
        beforeEnter: child.beforeEnter,
        meta: {
          title: subchild.title,
          parent: `${parent.name}_${child.name}`,
          icon: subchild.icon,
          goBackBtn: subchild.goBackBtn,
          permissions: subchild.permissions,
        },
      });
    });
  });
});
export default routes;
